import React from 'react';
import { SkeletonComponent } from '@design-system';

export const PdfViewerSkeleton: React.FC = () => {
    return (
        <div style={{ marginTop: '20px' }}>
            <SkeletonComponent
                count={1}
                style={{
                    height: '450px',
                    width: 'calc(100% - 8px)',
                    margin: 'auto',
                    borderRadius: '8px',
                    display: 'block'
                }}
            />

            <SkeletonComponent
                count={1}
                style={{
                    height: '44px',
                    width: '145px',
                    margin: 'auto',
                    borderRadius: '8px',
                    display: 'block'
                }}
            />
        </div>
    );
};
